import { render, staticRenderFns } from "./packageInfo.vue?vue&type=template&id=59c5fbf0&scoped=true"
import script from "./packageInfo.vue?vue&type=script&lang=js"
export * from "./packageInfo.vue?vue&type=script&lang=js"
import style0 from "./packageInfo.vue?vue&type=style&index=0&id=59c5fbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5fbf0",
  null
  
)

export default component.exports